export default __webpack_public_path__ + "static/media/Me-documentation.010d563d.md";